module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-break-fill-28698f03.svg";